import { FC } from "react";
import { ConfigProvider, Pagination, PaginationProps } from "antd";
import clsx from "clsx";

const PAGINATION_THEME = {
  components: {
    Pagination: {
      borderRadius: 8,
      colorText: "var(--color-font-subtle)",
      colorTextDisabled: "var(--color-font-disabled)",
      itemBg: "transparent",
      itemLinkBg: "transparent",
      colorBgTextHover: "var(--color-background-primary-lighter)",
      itemActiveBg: "var(--color-background-primary)",
      itemActiveColor: "var(--color-font-inverted)",
      itemActiveColorHover: "var(--color-font-inverted)",
    },
  },
};

const PaginationComponent: FC<PaginationProps> = ({ className, ...props }) => {
  return (
    <ConfigProvider theme={PAGINATION_THEME}>
      <Pagination
        hideOnSinglePage
        showSizeChanger={false}
        showQuickJumper={false}
        showPrevNextJumpers={false}
        className={clsx("self-center", className)}
        {...props}
      />
    </ConfigProvider>
  );
};

export default PaginationComponent;
